import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useMarket } from '../context/MarketContext';
import { isSupportedLanguage, getBestSupportedLanguageForCountry } from '../utils/countryLanguageEngine';

const LegacyRouteRedirect = () => {
    const location = useLocation();
    const { country, language } = useMarket();

    const pathname = location.pathname;
    const segments = pathname.replace(/^\/+|\/+$/g, '').split('/');
    const firstSegment = segments[0]?.toLowerCase();
    const secondSegment = segments[1]?.toLowerCase();

    // Check if the URL was /{2-letter-country}/{something-else}
    if (segments.length >= 2 && /^[a-z]{2}$/.test(firstSegment)) {
        // If the second segment is NOT a supported language (e.g. /my/product/12 or /my/ms/...)
        if (!isSupportedLanguage(secondSegment)) {
            const defaultLang = getBestSupportedLanguageForCountry(firstSegment);
            // If second segment looks like a page (e.g. 'product', 'cart') keep it, otherwise drop invalid lang
            const isLikelyLangCode = /^[a-z]{2,3}(-[a-z]{2})?$/.test(secondSegment);
            const remaining = isLikelyLangCode ? segments.slice(2).join('/') : segments.slice(1).join('/');
            const trailingSlash = remaining ? '/' : '';
            const target = `/${firstSegment}/${defaultLang}/${remaining ? remaining + trailingSlash : ''}${location.search || ''}`;
            return <Navigate to={target} replace />;
        }
    }

    // Country-only route: /my or /sa or /us
    if (segments.length === 1 && /^[a-z]{2}$/.test(firstSegment)) {
        const defaultLang = getBestSupportedLanguageForCountry(firstSegment);
        const target = `/${firstSegment}/${defaultLang}/${location.search || ''}`;
        return <Navigate to={target} replace />;
    }

    // Standard legacy URL: /product/123 -> /{country}/{language}/product/123
    const cleanSubpath = pathname.replace(/^\/+/, '');
    const targetCountry = (country || 'sa').toLowerCase();
    let targetLang = (language || 'ar').toLowerCase();
    if (!isSupportedLanguage(targetLang)) {
        targetLang = getBestSupportedLanguageForCountry(targetCountry);
    }
    const target = `/${targetCountry}/${targetLang}/${cleanSubpath}${location.search || ''}`;

    return <Navigate to={target} replace />;
};

export default LegacyRouteRedirect;
